import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "./AuthProvider";

export function ProtectedRoute() {
  const { user } = useAuth();
  const location = useLocation();
  if (!user) return <Navigate to="/login" replace state={{ from: location.pathname }}/>;
  if (user.mustChangePassword && location.pathname!=="/change-password") return <Navigate to="/change-password" replace/>;
  if (!user.mustChangePassword && location.pathname==="/change-password") return <Navigate to="/" replace/>;
  return <Outlet/>;
}
